export default {

  // nav bar
  home: 'Home',
  activities: 'To-Do',
  myprofile: 'Profile',
  settings: 'Settings',

  // home
  AN: 'Announcements',
  LM: 'Leaves',
  DB: 'Dashboard',
  ML: 'My Leaves',
  MLL: 'LIST VIEW',
  MSC: 'CALENDAR VIEW',
  NL: 'New Request',
  EL: 'Edit Request',
  UP: 'Upcoming Leaves',
  TUPD: 'Team\'s Upcoming Leave Schedule',
  TSC: 'Team Schedule',
  MS: 'My Monthly Schedule',
  RM: 'Remaining Leave',
  RMSub: 'Your Annual Leave Balance',
  BL: 'My Balances',
  TB: 'Team Balances',
  leaveApprovals: 'Approvals',
  NLE: 'On behalf of',
  pending: 'Pending',
  request: 'Request',
  TS: 'Timesheets',
  MT: 'My Timesheets',
  TSA: 'Timesheet Approval',
  CD: 'Client Details',
  CP: 'Client Projects',
  TTS: 'Team Timesheet',

  // HR Admin
  hrAdmin: 'Admin Timesheets',
  hrAdminDashboard: 'Dashboard',
  hrAdminCompany: 'Company',
  hrAdminEmployees: 'Employees',
  RecruitmentCandidates: 'Candidates',
  RecruitmentVacancies: 'Vacancies',
  hrAdminReports: 'Reports',
  hrAdminCompanyDocuments: 'Company Documents',
  hrAdminTrainings: 'Trainings',
  hrAdminClients: 'Clients',
  hrUtilities: 'Utilities',
  hrAdminAnalytics: 'Analytics',

  // Company Tab
  newCompany: 'New Company',
  editCompany: 'Edit Company',
  branches: 'Branches',
  locations: 'Locations',
  buildingFloors: 'Building Floors',
  functions: 'Functions',
  functionsServiceLinesDepts: 'Functions - Service Lines - Departments',
  serviceLines: 'Service Lines',
  departments: 'Departments',
  emplContext: 'Employee Context',
  staffLevel: 'Staff Levels',
  staffLevelSeniorityLevel: 'Staff Levels - Seniority Levels',
  seniorityLevels: 'Seniority Levels',
  jobTitles: 'Job Titles',
  leaveTypes: 'Leave Types',
  leaveSchemes: 'Leave Schemes',
  workflows: 'Workflows',
  emplAuth: 'Employee Authorizations',
  authorizations: 'Authorizations',
  salarySchemes: 'Salary Schemes',
  rates: 'Standard Charging Rates',
  employeeRates: 'Charging Rates',
  massUpload: 'Mass Data Upload',

  // Employees Tab
  editEmployee: 'Edit Employee',
  newEmployee: 'New Employee',
  leaveAnalysis: 'Leave Analysis',

  // to-do
  LAA: 'Leave Approvals',
  LAAadmin: 'Leaves Admin',

  // Employees Tab
  selectEmployee: 'Select Employee',
  newEmployee: 'New Employee',
  editEmployee: 'Edit Employee',
  leaveAnalysis: 'Leave Analysis',
  workflows: 'Workflows',
  reportsTo: 'Reports To',
  salaryReviews: 'Salary Reviews',
  academicQual: 'Academic Qualifications',
  additionalQual: 'Additional Qualifications',
  specialDoc: 'Special Documents',
  exitProcess: 'Exit Process',
  advSettings: 'Advanced Settings',

  // Training Tab
  trnCategories: 'Categories',
  trnSubjects: 'Subjects',
  training: 'Trainings',
  trnDetails: 'Training Details',
  courseDetails: 'Course Details',
  participants: 'Participants',
  modules: 'Modules',
  trnEvaluationForm: 'Evaluation Form',
  prerequisites: 'Prerequisites',
  trnMaterial: 'Training Material',
  MyTRN: "My Trainings",
  trnLAndDMethod: 'Learning and Development Method',
  trnLAndDNeed: 'Learning and Development Need',


  //Analytics
  employees: "Employees",
  leaves: "Leaves",
  groupBy: "Group Employees",
  averageAge: "Average Age",
  averageWorkingYears: "Avg Working Years",
  genderBreakdown: "Gender BreakDown",
  ageRanges: "Employees per Age Group",
  tenureRanges: "Active Workforce Tenure (Years)",
  female: "Female",
  male: "Male",
  attritionRate: "Attrition Rate",
  leavers: "Leavers",
  avgHeadcount: "Avg Headcount",
  employmentTypes: "Employment Types",
  qualificationTypes: "Qualifications",
  leaveRequestsPerMonth: "Approved Leaves Per Month",
  leaveRequestsHeatmap: "Monthly HeatMap",
  tapDayForDetails: "Tap a day for details",
  leaveDetailsForSelectedDay: "Selected Day Leave Details",
  approvedLeaves: "Approved Leaves",
  noData: "No Data",
  searchLeaveDetails: "Search by employee ID, name, type, date or duration",
  showingEmployeesOnLeave: "Showing Employees on Leave",
  noResults: "No Results",

  //Events
  EV: 'Events',
  MR: 'My Registrations',
  EF: 'Facilitators',

  //Alerts
  emplAlerts: 'Alerts',

  // Survey
  SR: 'Survey Response',
  CS: 'Create Survey',
  ES: 'Edit Survey',

  // profile
  personalInfo: 'Personal',
  emergencyInfo: 'Emergency',
  documents: 'Documents',
  preferences: 'Preferences',
  mydocuments: 'My Documents',


  // CURRENTLY NOT USED
  LA: 'Leave Analysis',
  MLS: 'Monthly Leave Scheduler',
  TLS: 'Team\'s Leave Schedule',
  TLB: 'Team\'s Leave Balances',
  HIST: 'History',
  AM: 'Assessments',
  SM: 'Surveys',
  AM: 'Assessments',

  filter: 'APPLY',
  sort: 'Sort',
  clear: 'CLEAR ',
  cancel: 'Cancel',

  //Shifts 
  shifts: 'Shifts',
  shiftTemplate: 'Shift Templates',
  shiftRoster: 'Shift Roster',
  shiftSchedulePeriods: 'Shift Schedule Periods',
  shiftAdmin: 'Shift Admin',
  createTemplate: 'Create Template',
  assignTemplate: 'Assign Template',
};
